
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M27.64 1c.907 0 1.693.333 2.36 1 .667.667 1 1.453 1 2.36v23.28c0 .907-.333 1.693-1 2.36-.667.667-1.453 1-2.36 1H4.36c-.907 0-1.693-.333-2.36-1-.667-.667-1-1.453-1-2.36V4.36c0-.907.333-1.693 1-2.36.667-.667 1.453-1 2.36-1h23.28zm-7.069 18.02a3.04 3.04 0 00-2.191.93 3.21 3.21 0 00-.423.543L12.6 17.16a3.226 3.226 0 000-2.348l5.357-3.308c.55.886 1.515 1.477 2.613 1.477 1.71 0 3.1-1.426 3.1-3.178s-1.39-3.178-3.1-3.178c-1.709 0-3.099 1.426-3.099 3.178 0 .4.075.78.207 1.132l-5.364 3.312a3.079 3.079 0 00-2.59-1.439c-1.71 0-3.1 1.426-3.1 3.178s1.39 3.178 3.1 3.178a3.078 3.078 0 002.59-1.44l5.363 3.338c-.133.358-.206.74-.206 1.135 0 .849.322 1.647.908 2.247a3.04 3.04 0 004.383 0c.585-.6.907-1.398.907-2.247s-.322-1.647-.907-2.247a3.04 3.04 0 00-2.192-.93z"}})])
          )
        }
      }
    